import { contractRateImport, planImport } from "_services";
import { getLorryTypeList } from "_services/accountsServices/lrServices";
import {
  getConsignorDropdownListData,
  getConsignorDropdownListData2,
  getContractDropdownListData,
} from "_services/dropdownServices/dropdownService";
import { ButtonExcelForQuick, CityDropdownForTrip, CommonInput, CustomSelect, ExcelDownload, Heading } from "components";
import { UserContext } from "context";
import { errorSchema, utils } from "helper";
import { VehicleTypeModal } from "modals";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import StorageService from "utils/StorageServices";

const ContractRatesUpload = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id'); // "1"
  const initial = {
    company_id: StorageService?.getCompanyId(),
    consignor_id: "",
    contract_id: "",
    branch_id: "",
    lorry_type_id: "",
    vehicle_type_id: "",
    matrix_allowed: 2,
    file: null,
  };
  const navigate = useNavigate();
  const { masterData } = useContext(UserContext);
  const [form, setForm] = useState(initial);
  const [formError, setFormError] = useState("");
  const [loading, setLoading] = useState(false);
  const [consignorList, setConsignorList] = useState([]);
  const [listData, setListData] = useState({
    consignorList: [],
    contractList: [],
    branchList: [],
  });
  const [hasMoreVehicle, setHasMoreVehicle] = useState(true);
  const [page, setPage] = useState(1);
  const [planInportList, setPlanInportList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [statusCounts, setStatusCounts] = useState({
    Rejected: 0,
    Updated: 0,
    Added: 0,
    All: 0,
  });
  const [vehicleTypeshow, setVehicleTypeShow] = useState(false);
  const [vehicleTypeLabel, setVehicleTypeLabel] = useState({
    label: "",
    value: "",
  });

  const [lorryType, setLorryType] = useState([]);
  const [contractZoneList, setContractZoneList] = useState([]);


  // useEffect(() => {
  //   fetchPartyList();
  // }, []);

  useEffect(() => {
    if (masterData) {
      fetchData();
    }
  }, [masterData]);

  useEffect(() => {
    if (form?.consignor_id?.value) {
      getContractList(form?.consignor_id?.value);
      getVehicleTypeList();
    }
  }, [form?.consignor_id?.value]);


  const fetchConsignor = async (search, page, limit) => {
    const res = await getConsignorDropdownListData2({
      company_id: StorageService.getCompanyId(),
      firm_id: StorageService.getFirmId(),
      offset: page,
      limit,
      search,

    });
    if (res?.responseCode === 200) {
      const list = res?.data?.consignor_list.map((c) => ({ ...c, value: c._id, label: c.name }))
      if (!form?.contract_id) {
        if (page == 1) {
          // setConsignorList(list);
          setInitialFormValues(
            "consignor_id",
            list[0]
          );

        }
      }

      return {

        items: [...list],

        total: res?.data?.total_record,
      };

    } else {
      toast.error(res?.responseMessage);
    }
  };

  const fetchData = async () => {
    try {
      const categoryList = formatList(
        masterData?.contract_matrix_allowed_list,
        "name",
        "id"
      );

      setContractZoneList(categoryList);
      setForm((pre) => ({ ...pre, matrix_allowed: id == 1 ? 2 : 1 }));

      // setInitialFormValues(categoryList);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data", error);
    }
  };

  const handleOnChange = async (name, value) => {
    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        [name]: value,
      };

      if (formError) {
        utils
          .checkFormError(
            {
              ...updatedForm,
            },
            errorSchema.contractImportSchema
          )
          .then((validationResult) => {
            if (validationResult === true) {
              setFormError("");
            } else {
              setFormError(validationResult);
            }
          });
      }

      return updatedForm;
    });
  };

  //file

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validTypes = [
        "text/csv",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      if (validTypes.includes(file.type)) {
        handleOnChange("file", file);
        setFormError({
          ...formError,
          file: "",
        });
      } else {
        setFormError({
          ...formError,
          file: "Please upload only CSV or XLSX files.",
        });
      }
    }
  };

  //common Api function
  const commonFetchFuction = async (
    apiMethod,
    payload = {},
    transformer = (res) => res
  ) => {
    try {
      const res = await apiMethod(payload);
      if (res?.responseCode === 200) {
        return transformer(res);
      } else {
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  //common formate for dropdown

  const formatList = (list, labelKey, valueKey, defaultOption = null) => {
    const formattedList = list?.map((item) => ({
      ...item,
      label: item[labelKey],
      value: item[valueKey],
    }));
    return defaultOption
      ? [{ label: defaultOption, value: "" }, ...formattedList]
      : formattedList;
  };

  //set initial value

  const setInitialFormValues = (name, value) => {
    handleOnChange(name, value || "");
  };

  const getConsignorList = async (page = 1, limit = 10) => {
    let consignorRes = await commonFetchFuction(getConsignorDropdownListData, {
      company_id: StorageService.getCompanyId(),
      firm_id: StorageService.getFirmId(),
      offset: page,
      limit,
    });

    return consignorRes;
  };

  // const fetchPartyList = async (nextPage = 1) => {
  //   try {
  //     const res = await getConsignorList(nextPage, 2000);

  //     if (res?.responseCode === 200) {
  //       const newVehicles = res?.data?.consignor_list.map((i) => ({
  //         ...i,
  //         label: i.name,
  //         value: i._id,
  //       }));

  //       if (nextPage == 1) {
  //         setConsignorList(newVehicles);
  //         setInitialFormValues("consignor_id", newVehicles[0]?._id);
  //       } else {
  //         setConsignorList((prevList) => [...prevList, ...newVehicles]);
  //       }

  //       if (newVehicles.length < 10) {
  //         setHasMoreVehicle(false);
  //       } else {
  //         setHasMoreVehicle(true);
  //         setPage(nextPage + 1);
  //       }
  //     } else {
  //       toast.error(res?.responseMessage);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching vehicle list:", error);
  //     toast.error("Error fetching vehicle list.");
  //   }
  // };

  const getContractList = async (contarct) => {
    const payload = {
      company_id: StorageService.getCompanyId(),
      consignor_id: contarct,
      limit: 100,
      offset: 1,
      search: "",
    };
    try {
      const contractRes = await commonFetchFuction(
        getContractDropdownListData,
        payload
      );

      setListData({
        ...listData,
        contractList: formatList(
          contractRes?.data?.contract_list,
          "name",
          "_id"
        ),
      });

      setForm((pre) => ({ ...pre, matrix_allowed: contractRes?.data?.contract_list?.find((i) => i.active == 1).matrix_allowed }))

      setInitialFormValues(
        "contract_id",
        contractRes?.data?.contract_list?.find((i) => i.active == 1)._id
      );
    } catch (error) {
      toast.error("Error fetching data", error);
    }
  };

  const getVehicleTypeList = async () => {
    const payload = {
      company_id: StorageService.getCompanyId(),
      limit: 100,
      offset: 1,
      search: "",
    };
    try {
      const contractRes = await getLorryTypeList(payload);

      setLorryType(contractRes.data?.lorry_type);
    } catch (error) {
      toast.error("Error fetching data", error);
    }
  };

  const handleImportFile = async () => {
    const formData = new FormData();
    Object.keys(form).forEach((key) => {
      if (key === "consignor_id" && form[key]) {
        formData.append(key, form[key].value);
      } else if (key === "file" && form[key]) {
        formData.append(key, form[key]);
      } else if (form[key] !== undefined && form[key] !== null) {
        formData.append(key, form[key]);
      }
    });

    const validationResult = await utils.checkFormError(
      { ...form },
      errorSchema.contractImportSchema
    );
    if (validationResult == true) {
      setLoading(true);
      try {
        const res = await contractRateImport(formData);
        if (res?.responseCode == 200) {
          setLoading(false);
          setPlanInportList(res?.data?.results);
          toast?.success(res?.responseMessage);

          const execleDat = res?.data?.results?.map((i) => {
            return {
              from_zone: i?.value?.from_zone ? i?.value?.from_zone : "",
              to_zone: i?.value?.to_zone ? i?.value?.to_zone : "",
              status: i?.status,
              remark: i?.remarks,
            };
          });
          const counts = res?.data?.results.reduce(
            (acc, item) => {
              if (item.status === "Not Updated") acc.Rejected++;
              if (item.status === "Updated") acc.Updated++;
              if (item.status === "Added") acc.Added++;
              acc.All++;
              return acc;
            },
            { Rejected: 0, Updated: 0, Added: 0, All: 0 }
          );

          setStatusCounts(counts);
          // setForm({ consignor_id: "", contract_id: "", branch_id: "", file: "" });
          setTableData([...execleDat]);
        } else {
          setLoading(false);
        }
      } catch (error) {
        toast.error(error);
      }
    } else {
      setFormError(validationResult);
    }
  };



  const callBackVehicleType = (value) => {

    handleOnChange("lorry_type_id", value?.activeTab?._id)
    handleOnChange("vehicle_type_id", value?.tyre?.value)
    // setForm({
    //   ...form,
    //   lorry_type_id: value?.activeTab?._id,
    //   vehicle_type_id: value?.tyre?.value,
    // });
    setVehicleTypeLabel({
      label: `${value?.activeTab?.lorry_type} > ${value?.tyre?.label}`,
      value: "",
    });
    setVehicleTypeShow(false);
  };

  let vehicleTypeProps = {
    isOpen: vehicleTypeshow,
    closeModal: (e) => setVehicleTypeShow(false),
    headerPart: true,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Vehicle Type",
    submitTitle: "Save",
    isLoadding: loading,
    disabled: loading ? true : false,
    lorryType: lorryType,
    callBackVehicleType: callBackVehicleType,
  };

  return (
    <>
      <Heading title="Contract Rate Upload" />

      <div className="_Qwk_inr">
        <div className="_tierPart">
          {/* <CustomSelect
            label="Party"
            placeholder="Select Party"
            options={consignorList}
            value={consignorList?.find((i) => i?.value == form?.consignor_id)}
            onSelect={(data) => {
              handleOnChange("consignor_id", data?.value);
            }}
            enableInfiniteScroll={consignorList.length > 4 ? true : false}
            fetchMoreData={() => fetchPartyList(page)}
            hasMore={hasMoreVehicle}
          /> */}
          <CityDropdownForTrip
            key={`Party`}
            label="Party"
            placeholder="Select Party"
            fetchData={fetchConsignor}
            // isAddButton={true}
            // addButtonAction={(e) => addNewItemHandler(e)}
            pageSize={20}
            onChange={(data) => handleOnChange("consignor_id", data)}

            selectedItem={form?.consignor_id}
            error={!!formError["city.name"]}
            errorMessage={
              formError["city.name"]
            }
          // withState={true}
          />
        </div>

        <div className="_tierPart">
          <CustomSelect
            label="Contract"
            placeholder={"Select Contract"}
            options={listData?.contractList}
            value={listData?.contractList?.find(
              (i) => i?.value == form?.contract_id
            )}
            onSelect={(data) => {
              handleOnChange("contract_id", data?.value);
            }}
          />
        </div>

        <div className="_tierPart" onClick={() => setVehicleTypeShow(true)}>
          <CustomSelect
            label="Vehicle Type"
            placeholder="Select Vehicle Type"
            options={[{ label: "Vehicle Number", value: "123" }]}
            value={vehicleTypeLabel}
            openList={false}
            error={formError.vehicle_type_id}
          />
        </div>
        <div className="_tierPart">
          <CustomSelect
            label="Matrix"
            placeholder="Select Matrix"
            disabled={form?.matrix_allowed}
            options={contractZoneList}
            value={contractZoneList?.find(
              (i) => i?.value == form?.matrix_allowed
            )}
            onSelect={(data) => {
              handleOnChange("matrix_allowed", data?.value);
            }}
          />
        </div>
        <div className="_exceluploadBx">
          <CommonInput
            type="file"
            onChange={handleFileChange}
            accept=".csv, .xlsx"
            error={formError?.file}
          />
        </div>
        <ButtonExcelForQuick name={form?.matrix_allowed == 1 ? "Contract_Rate_City_City" : form?.matrix_allowed == 2 ? "Contract_Rate_Zone_Zone" : ""} />
        <button
          className="_flUpload_btn"
          disabled={loading}
          onClick={() => handleImportFile()}
        >
          {loading ? "Uploading.." : "Upload File"}
        </button>
      </div>

      {planInportList?.length > 0 && (
        <div className="tbdFilts_bx">
          <div className="_hedFilts">
            <h4>Status</h4> <ExcelDownload tableData={tableData} />
          </div>

          <div className="_tbdOx_bx">
            <div className="_fourTbx">
              <h4>{statusCounts?.All}</h4>
              <p className="__successTxt">All</p>
            </div>

            <div className="_fourTbx">
              <h4>{statusCounts?.Added}</h4>
              <p className="__successTxt">Added</p>
            </div>

            <div className="_fourTbx">
              <h4>{statusCounts?.Updated}</h4>
              <p className="__successTxt">Updated</p>
            </div>

            <div className="_fourTbx">
              <h4>{statusCounts?.Rejected}</h4>
              <p className="__rejectTxe">Not Updated</p>
            </div>
          </div>
        </div>
      )}

      {planInportList?.length > 0 && (
        <div className="_qwkTable_dix">
          <div className="_indentTable _disPatchView _fuelCrd__table">
            <table>
              <thead>
                <tr>
                  <th>From Zone</th>
                  <th>To Zone</th>
                  <th>Status</th>
                  <th>Remarks</th>
                </tr>
              </thead>

              <tbody>
                {tableData?.length &&
                  tableData?.map((i) => {
                    return (
                      <tr>
                        <td>
                          <div className=" ">
                            <p className="_tblText_inDent">{i?.from_zone || ""}</p>
                          </div>
                        </td>
                        <td>
                          <div className=" ">
                            <p className="_tblText_inDent">{i?.to_zone || ""}</p>
                          </div>
                        </td>

                        <td>
                          <div className=" ">
                            <p
                              className={`_tblText_inDent${i?.status == "Not Updated"
                                ? " __rejectTxe"
                                : " __successTxt"
                                }`}
                            >
                              {i?.status || ""}
                            </p>
                          </div>
                        </td>

                        <td>
                          <div className=" ">
                            <p className="">{i?.remark || ""}</p>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {vehicleTypeshow && <VehicleTypeModal {...vehicleTypeProps} />}
    </>
  );
};

export default ContractRatesUpload;
